// extracted by mini-css-extract-plugin
module.exports = {"height_particles":"100vh"};